import React from 'react';
import { Alert, AlertTitle, Button } from '@mui/material';

export default function BookingShareNotice({ status, onEdit }) {
  if (!status) return null;
  return <Alert severity={status.severity} sx={{ my: 1 }} action={onEdit && <Button color="inherit" size="small" onClick={() => onEdit(status.target)}>{status.action}</Button>}>
    <AlertTitle>{status.title}</AlertTitle>{status.message}
  </Alert>;
}
